export default [
  ['appointment', 'img/appointment.svg'],
  ['brandModel', 'img/brand-model.svg'],
  ['callMeBack', 'img/call-me-back.svg'],
  ['cancelModal', 'img/cancel-modal.svg'],
  ['carFuelType', 'img/car-fuel-type.svg'],
  ['carFuelType-2', 'img/car-fuel-type-2.svg'],
  ['carPark', 'img/car-park.svg'],
  ['carPark-2', 'img/car-park-2.svg'],
  ['carUpsideDown', 'img/car-upside-down.svg'],
  ['carUpsideDown-2', 'img/car-upside-down-2.svg'],
  ['carOffRoad-2', 'img/car-off-road-2.svg'],
  ['carOffRoad', 'img/car-off-road.svg'],
  ['personWithSpecialNeeds', 'img/person-with-special-needs.svg'],
  ['personWithSpecialNeeds-2', 'img/person-with-special-needs-2.svg'],
  ['carDrivable', 'img/car-drivable.svg'],
  ['carDrivable-2', 'img/car-drivable-2.svg'],
  ['confirmation', 'img/confirmation.svg'],
  ['confirmationModal', 'img/confirmation-modal.svg'],
  ['delivery1', 'img/delivery1.svg'],
  ['delivery2', 'img/delivery2.svg'],
  ['eligibility', 'img/eligibility.svg'],
  ['eligibility-2', 'img/eligibility-2.svg'],
  ['endAppointment', 'img/end-appointment.svg'],
  ['endMission', 'img/end-mission.svg'],
  ['endLocation', 'img/end-location.svg'],
  ['event', 'img/event.svg'],
  ['event-ACCIDENT', 'img/event-accident.svg'],
  ['event-ACCIDENT-2', 'img/event-accident-2.svg'],
  ['event-BATTERY_PROBLEM', 'img/event-battery-problem.svg'],
  ['event-BATTERY_PROBLEM-2', 'img/event-battery-problem-2.svg'],
  ['event-BREAKDOWN', 'img/event-breakdown.svg'],
  ['event-BREAKDOWN-2', 'img/event-breakdown-2.svg'],
  ['event-LACK_OF_ENERGY', 'img/event-lack-of-energy.svg'],
  ['event-EMPTY_FUEL', 'img/event-empty-fuel.svg'],
  ['event-EMPTY_FUEL-2', 'img/event-empty-fuel-2.svg'],
  ['event-FLAT_TIRE', 'img/event-flat-tire.svg'],
  ['event-FLAT_TIRE-2', 'img/event-flat-tire-2.svg'],
  ['event-STUCK', 'img/event-stuck.svg'],
  ['event-STUCK-2', 'img/event-stuck-2.svg'],
  ['event-THEFT_BREAKIN', 'img/event-theft-breakin.svg'],
  ['event-THEFT_BREAKIN-2', 'img/event-theft-breakin-2.svg'],
  ['event-WRONG_FUEL', 'img/event-wrong-fuel.svg'],
  ['event-WRONG_FUEL-2', 'img/event-wrong-fuel-2.svg'],
  ['event-NATURAL_DISASTER-2', 'img/event-natural-disaster-2.svg'],
  ['event-CRASH-2', 'img/event-crash-2.svg'],
  ['event-INFORMATIVE_CALL-2', 'img/event-informative-call-2.svg'],
  ['event-DRIVING_LICENCE_REVOCATION-2', 'img/event-driving-licence-revocation-2.svg'],
  ['event-THEFT_WITH_KEYS', 'img/event-theft-with-keys.svg'],
  ['event-THEFT_WITH_KEYS-2', 'img/event-theft-with-keys-2.svg'],
  ['event-KEY_BROKEN', 'img/event-key-broken.svg'],
  ['event-KEY_BROKEN-2', 'img/event-key-broken-2.svg'],
  ['event-KEY_IN_CAR', 'img/event-key-in-car.svg'],
  ['event-KEY_IN_CAR-2', 'img/event-key-in-car-2.svg'],
  ['event-KEY_LOST', 'img/event-key-lost.svg'],
  ['event-KEY_LOST-2', 'img/event-key-lost-2.svg'],
  ['event-FROZEN_FUEL', 'img/event-frozen-fuel.svg'],
  ['event-THEFT_ATTEMPT', 'img/event-theft-attempt.svg'],
  ['event-VANDALISM', 'img/event-vandalism.svg'],
  ['event-WINDSCREEN', 'img/event-windscreen.svg'],
  ['event-FIRE', 'img/event-fire.svg'],
  ['event-BAD_WEATHER', 'img/event-bad-weather.svg'],
  ['event-OTHER', 'img/event-other.svg'],
  ['filledFuelType', 'img/filled-fuel-type.svg'],
  ['highway', 'img/highway.svg'],
  ['highway-2', 'img/highway-2.svg'],
  ['highwayDirection', 'img/highway-direction.svg'],
  ['referentialHighwayDirection', 'img/referential-highway-direction.svg'],
  ['highwayProcess', 'img/highway.svg'],
  ['identification', 'img/identification.svg'],
  ['logo', 'img/header.svg'],
  ['milestone', 'img/milestone.svg'],
  ['modalError', 'img/modal-error.svg'],
  ['modalTimedOut', 'img/modal-timed-out.svg'],
  ['modalVehiculeLocation', 'img/modal-vehicle-location.svg'],
  ['mission', 'img/mission.svg'],
  ['numberOfPassengers', 'img/number-of-passengers.svg'],
  ['numberOfPassengers-2', 'img/number-of-passengers-2.svg'],
  ['providerArrival', 'img/provider-arrival.svg'],
  ['hybridEnergy', 'img/hybrid-energy.svg'],
  ['spareTire', 'img/spare-tire.svg'],
  ['spareTire-2', 'img/spare-tire-2.svg'],
  ['splash1', 'img/accident.svg'],
  ['splash2', 'img/assistance.svg'],
  ['updateModal', 'img/update-modal.svg'],
  ['voiceExit', 'img/voice-exit.svg'],
  ['welcome', 'img/welcome.svg'],
  ['windscreenDetails', 'img/windscreen-details.svg'],
  ['windscreenDetails-2', 'img/windscreen-details-2.svg'],
  ['ros', 'img/ros.svg'],
  ['tow', 'img/tow.svg'],
  ['fnolAppointment', 'img/fnol-appointment.svg'],
  ['vehicleDamage', 'img/vehicle-damage.svg'],
  ['policeOnSpot', 'img/police-on-spot.svg'],
  ['otherVehicleInvolved', 'img/other-vehicle-involved.svg'],
  ['fnolCircumstancesDetails', 'img/fnol-circumstances-details.svg'],
  ['fnolDamagesQuestion', 'img/fnol-damages-question.svg'],
  ['fnolDamagesPosition', 'img/fnol-damages-position.svg'],
  ['fnolAccidentReport', 'img/fnol-accident-report.svg'],
  ['fnolThirdPartyInfo', 'img/fnol-third-party-info.svg'],
  ['fnolContactInformation', 'img/fnol-contact-information.svg'],
  ['fnolVehicleInformation', 'img/fnol-vehicle-information.svg'],
  ['cookiebutton', 'img/cookie-button.svg'],
  ['customGarage', 'img/custom-destination.svg'],
  ['premiumGarage', 'img/premium-garage.svg'],
  ['contextGarageNetwork', 'img/garage_off_icon.svg'],
  ['vehicleCondition', 'img/vehicle-condition.svg'],
  ['vehicleUpsideDown', 'img/vehicle-upside-down.svg'],
  ['vehicleOffRoad', 'img/vehicle-off-road.svg'],
  ['disasterType', 'img/disaster.svg'],
  ['KeyBroken', 'img/broken-key.svg'],
  ['DrivingLicenceRevocationDetails', 'img/dlr.svg'],
  ['FoundAfterTheft', 'img/found-after-theft.svg'],
  ['replacementKey', 'img/replacement-key.svg'],
  ['taxi', 'img/taxi.svg'],
  ['rental', 'img/rental.svg'],
  ['rental-pickup-time', 'img/rental-pickup-time.svg'],
  ['rental-dropoff-time', 'img/rental-dropoff-time.svg'],
  ['taxi-provider', 'img/taxi-provider.svg'],
  ['passengers', 'img/passengers.svg'],
  ['luggage', 'img/luggage.svg'],
  ['taxi-pickup-address', 'img/taxi-pickup-address.svg'],
  ['taxi-dropoff-address', 'img/taxi-dropoff-address.svg'],
  ['vehicle-immobilization', 'img/vehicle-immobilization.svg'],
  ['vehicle-immobilization-time', 'img/vehicle-immobilization-time.svg'],
  ['taxi-embedded-selected', 'img/taxi-embedded-selected.svg'],
  ['rental-embedded-selected', 'img/rental-embedded-selected.svg'],
  ['tow-embedded-selected', 'img/tow-embedded-selected.svg'],
  ['ros-embedded-selected', 'img/ros-embedded-selected.svg'],
  ['vehicle-immobilization-embedded-selected', 'img/vehicle-immobilization-embedded-selected.svg'],
  ['taxi-embedded', 'img/taxi-embedded.svg'],
  ['rental-embedded', 'img/rental-embedded.svg'],
  ['tow-embedded', 'img/tow-embedded.svg'],
  ['ros-embedded', 'img/ros-embedded.svg'],
  ['vehicle-immobilization-embedded', 'img/vehicle-immobilization-embedded.svg'],
  ['event-ACCIDENT-2-embedded', 'img/event-accident-2-embedded.svg'],
  ['event-BATTERY_PROBLEM-2-embedded', 'img/event-battery-problem-2-embedded.svg'],
  ['event-BREAKDOWN-2-embedded', 'img/event-breakdown-2-embedded.svg'],
  ['event-EMPTY_FUEL-2-embedded', 'img/event-empty-fuel-2-embedded.svg'],
  ['event-FLAT_TIRE-2-embedded', 'img/event-flat-tire-2-embedded.svg'],
  ['event-STUCK-2-embedded', 'img/event-stuck-2-embedded.svg'],
  ['event-THEFT_BREAKIN-2-embedded', 'img/event-theft-breakin-2-embedded.svg'],
  ['event-WRONG_FUEL-2-embedded', 'img/event-wrong-fuel-2-embedded.svg'],
  ['event-NATURAL_DISASTER-2-embedded', 'img/event-natural-disaster-2-embedded.svg'],
  ['event-CRASH-2-embedded', 'img/event-crash-2-embedded.svg'],
  ['event-INFORMATIVE_CALL-2-embedded', 'img/event-informative-call-2-embedded.svg'],
  ['event-DRIVING_LICENCE_REVOCATION-2-embedded', 'img/event-driving-licence-revocation-2-embedded.svg'],
  ['event-THEFT_WITH_KEYS-2-embedded', 'img/event-theft-with-keys-2-embedded.svg'],
  ['event-KEY_BROKEN-2-embedded', 'img/event-key-broken-2-embedded.svg'],
  ['event-KEY_IN_CAR-2-embedded', 'img/event-key-in-car-2-embedded.svg'],
  ['event-KEY_LOST-2-embedded', 'img/event-key-lost-2-embedded.svg'],
  ['event-ACCIDENT-2-embedded-selected', 'img/event-accident-2-embedded-selected.svg'],
  ['event-BATTERY_PROBLEM-2-embedded-selected', 'img/event-battery-problem-2-embedded-selected.svg'],
  ['event-BREAKDOWN-2-embedded-selected', 'img/event-breakdown-2-embedded-selected.svg'],
  ['event-EMPTY_FUEL-2-embedded-selected', 'img/event-empty-fuel-2-embedded-selected.svg'],
  ['event-FLAT_TIRE-2-embedded-selected', 'img/event-flat-tire-2-embedded-selected.svg'],
  ['event-STUCK-2-embedded-selected', 'img/event-stuck-2-embedded-selected.svg'],
  ['event-THEFT_BREAKIN-2-embedded-selected', 'img/event-theft-breakin-2-embedded-selected.svg'],
  ['event-WRONG_FUEL-2-embedded-selected', 'img/event-wrong-fuel-2-embedded-selected.svg'],
  ['event-NATURAL_DISASTER-2-embedded-selected', 'img/event-natural-disaster-2-embedded-selected.svg'],
  ['event-CRASH-2-embedded-selected', 'img/event-crash-2-embedded-selected.svg'],
  ['event-INFORMATIVE_CALL-2-embedded-selected', 'img/event-informative-call-2-embedded-selected.svg'],
  ['event-DRIVING_LICENCE_REVOCATION-2-embedded-selected', 'img/event-driving-licence-revocation-2-embedded-selected.svg'],
  ['event-THEFT_WITH_KEYS-2-embedded-selected', 'img/event-theft-with-keys-2-embedded-selected.svg'],
  ['event-KEY_BROKEN-2-embedded-selected', 'img/event-key-broken-2-embedded-selected.svg'],
  ['event-KEY_IN_CAR-2-embedded-selected', 'img/event-key-in-car-2-embedded-selected.svg'],
  ['event-KEY_LOST-2-embedded-selected', 'img/event-key-lost-2-embedded-selected.svg'],
  ['additionalTransportation', 'img/additional-transportation.svg'],
  ['dashboard', 'img/dashboard.svg'],
  ['dashboard-2', 'img/dashboard-2.svg'],
  ['failed-identification', 'img/failed-identification.svg'],
  ['provider', 'img/provider.svg'],
  ['provider-embedded', 'img/provider-embedded.svg'],
  ['provider-embedded-selected', 'img/provider-embedded-selected.svg'],
  ['intermediaryStop', 'img/intermediaryStop.svg'],
  ['intermediaryStop-embedded', 'img/intermediaryStop-embedded.svg'],
  ['intermediaryStop-embedded-selected', 'img/intermediaryStop-embedded-selected.svg'],
  ['calendar', 'img/calendar.svg'],
  ['vlt', 'img/vehicle-transportation.svg'],
  ['rental-driver-details', 'img/rental-driver-details.svg'],
  ['location', 'img/location.svg'],
  ['address-book', 'img/address-book.svg'],
  ['checkmark', 'img/checkmark.svg'],
  ['rental-registration', 'img/rental-registration.svg'],
  ['POILocation', 'img/poi-location.svg'],
  ['verificationIssue', 'img/verification-issue.svg'],
  ['security', 'img/security.svg'],
  ['info', 'img/info.svg'],
];
